import React from 'react';
import { t } from 'ttag';
import { Button } from '@coolremote/shared';
import { SupportTicket } from '../../../../icons/';
import assetsService from '../../../../services/assetsService';

const SupportButton = ({
  theme,
  configFile,
  onReportProblem
}) => {
  const handleClick = () => {
    if (configFile?.supportBtnLink?.length) {
      window?.open(configFile?.supportBtnLink, '_blank')?.focus();
      return;
    }
    onReportProblem();
  };

  return (
    <Button
      disableRipple
      variant="contained"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        minWidth: '60px',
        backgroundColor: theme === 'dark' ? '#333333' : '#1976d2',
        color: theme === 'dark' ? '#ffffff' : '#ffffff',
        zIndex: 9999,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        '&:hover': {
          backgroundColor: theme === 'dark' ? '#444444' : '#1565c0',
        }
      }}
      onClick={handleClick}
      title={t`Open Support Ticket`}
    >
      {configFile?.supportImg ? (
        <img
          src={assetsService.getResourcePath(configFile?.supportImg)}
          alt=""
          style={{ width: "3.4rem", height: '3.4rem' }}
        />
      ) : (
        <SupportTicket width={"2rem"} height={"2rem"} />
      )}
    </Button>
  );
};

export { SupportButton };
